import { createAction } from '@reduxjs/toolkit'

import type { ApiUsage } from '@/services/apiUsage'

export const ApiUsageActions = {
  fetch: createAction('API_USAGE_FETCH'),
}

export const InternalApiUsageActions = {
  set: createAction<ApiUsage>('API_USAGE_SET'),
  setError: createAction<boolean>('API_USAGE_SET_ERROR'),
}
